import { render, staticRenderFns } from "./custom.vue?vue&type=template&id=23b4dd1d&scoped=true&"
import script from "./custom.vue?vue&type=script&lang=js&"
export * from "./custom.vue?vue&type=script&lang=js&"
import style0 from "./custom.vue?vue&type=style&index=0&id=23b4dd1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b4dd1d",
  null
  
)

export default component.exports